import { combineReducers } from 'redux';

import { IEntityActions } from '../../../../../data/store';
import { Actions as QualityActions, ActionTypes as QualityActionTypes } from '../../../../../entities/quality/actions';
import { Actions as PropertyViewActions, ActionTypes as PropertyViewActionTypes } from '../actions';

export const loadingProperty = (state = false, action: PropertyViewActions = {} as any) => {
	switch (action.type) {
		case PropertyViewActionTypes.ADMIN_VIEW_PROPERTY_REQUEST:
			return true;
		case PropertyViewActionTypes.ADMIN_VIEW_PROPERTY_RECEIVE:
		case PropertyViewActionTypes.ADMIN_VIEW_PROPERTY_FAILURE:
			return false;
		default:
			return state;
	}
};

export const loadingQuality = (state = false, action: QualityActions = {} as any) => {
	switch (action.type) {
		case QualityActionTypes.QUALITY_GET_BY_PROPERTY_ID_RECEIVE:
			return true;
		case QualityActionTypes.QUALITY_GET_BY_PROPERTY_ID_RECEIVE:
		case QualityActionTypes.QUALITY_GET_BY_PROPERTY_ID_FAILURE:
			return false;
		default:
			return state;
	}
};

export const savingProperty = (state = false, action: IEntityActions = {} as any) => {
	switch (action.type) {
		case 'PROPERTY_UPDATE_REQUEST':
			return true;
		case 'RESTRICTIONS_BY_PROPERTY_RECEIVE':
		case 'RESTRICTIONS_BY_PROPERTY_FAILURE':
		case 'PROPERTY_UPDATE_RECEIVE':
		case 'PROPERTY_UPDATE_FAILURE':
			return false;
		default:
			return state;
	}
};

export interface IAdminPropertyViewPageState {
	loadingProperty: ReturnType<typeof loadingProperty>;
	loadingQuality: ReturnType<typeof loadingQuality>;
	savingProperty: ReturnType<typeof savingProperty>;
}

export default combineReducers<IAdminPropertyViewPageState>({
	loadingProperty,
	loadingQuality,
	savingProperty
});
